import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "@/components/Input";
import { Typography } from "@/components/Typography";
import { FeedbackNavigation } from "./FeedbackNavigation";
import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

export const AddInfoFeedback = ({ data, hasMultipleCategories }) => {
  const { t } = useTranslation("feedback");
  const { form } = data;

  const qrFeedbackContextData = useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { reviewContactData, setReviewContactData } = qrFeedbackContextData;

  const [reviewAddDataForm, setReviewAddDataForm] = useState(reviewContactData);

  const handleReviewAddDataForm = (e) => {
    const inputValue = e?.target.value;
    setReviewAddDataForm({
      ...reviewAddDataForm,
      ...(inputValue && { [e.target.name]: inputValue }),
    });
  };

  useEffect(() => {
    setReviewContactData(reviewAddDataForm);
  }, [reviewAddDataForm]);

  const contactDataForm = Object.keys(form).filter((key) => form[key] === true);
  const getInputPlaceholder = (name) => {
    switch (name) {
      case "name":
        return t("submission_form_name_placeholder");
      case "email":
        return t("submission_form_email_placeholder");
      case "phone":
        return t("submission_form_phone_placeholder");
      default:
        break;
    }
  };

  return (
    <>
      <FeedbackNavigation hasMultipleCategories={hasMultipleCategories} />

      <div className="feedback-template__add-info">
        <div className="feedback-template__add-info-header">
          <div className="feedback-template__add-info-title">
            <Typography
              Tag="p"
              classname="u-semibold u-spacing-4"
            >
              {t("add_details_title")}
            </Typography>
          </div>

          <div className="feedback-template__add-info-description">
            <Typography
              Tag="p"
              classname="u-spacing-4"
            >
              {t("add_details_subtitle")}
            </Typography>
          </div>
        </div>

        <div className="feedback-template__add-info-form">
          {contactDataForm?.map((input, i) => (
            <Input
              id="feedback-name"
              type="text"
              label={t(`submission_form_${input}`)}
              name={input}
              placeholder={getInputPlaceholder(input)}
              onChange={(e) => handleReviewAddDataForm(e)}
              key={i}
            />
          ))}
        </div>
      </div>
    </>
  );
};
